import { render } from "./ChartOfAccountList.vue?vue&type=template&id=52519336&scoped=true"
import script from "./ChartOfAccountList.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountList.vue?vue&type=script&lang=js"

import "./ChartOfAccountList.vue?vue&type=style&index=0&id=52519336&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52519336"]])

export default __exports__